import { CheckableField, FormField } from '@msaf/core-react'

interface NoAquiferTestsInterface {
  isChecked?: boolean
  handleNoTestsCheckbox?: (checked: boolean) => void
  isViewMode?: boolean
}

export default function NoAquiferTests({ isChecked, handleNoTestsCheckbox, isViewMode }: NoAquiferTestsInterface) {
  return (
    <>
      {isViewMode ? (
        <p>There is no aquifer test information available for this record</p>
      ) : (
        <FormField label={`No aquifer tests have been added.`} labelId='noAquiferTestsLabelId'>
          <CheckableField
            type='checkbox'
            id='noAquiferTestsId'
            name='noAquiferTests'
            describedBy='noAquiferTestsLabelId'
            label='There is no aquifer test information available for this record'
            checked={!!isChecked}
            onChange={(e) => handleNoTestsCheckbox && handleNoTestsCheckbox(e.target.checked)}
          />
        </FormField>
      )}
    </>
  )
}
